import React from 'react';
import styled from 'styled-components';
import {SUPPORT_EMAIL, SUPPORT_MAILTO, SUPPORT_TELEGRAM} from '@shared/config/env';

const SupportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 300;
  color: #FEFFFF;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  color: rgba(254, 255, 255, 0.8);
  max-width: 600px;
  line-height: 1.6;
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const SupportButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: rgb(194, 143, 90);
  color: #FEFFFF;
  text-decoration: none;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgb(194, 143, 90);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(194, 143, 90, 0.4);
  }
  
  @media (max-width: 768px) {
    padding: 14px 24px;
    font-size: 16px;
  }
`;

const TelegramIcon = styled.svg`
  width: 24px;
  height: 24px;
`;

export const Support: React.FC = () => {
  return (
    <SupportWrapper>
      <Title>Поддержка</Title>
      <Description>
        Наша команда поддержки всегда готова помочь вам! 
        Мы отвечаем быстро и стараемся решить любой вопрос.
        <br /><br />
        Связаться с нами можно по почте — просто нажмите на кнопку ниже.
      </Description>
      <SupportButton 
        href={SUPPORT_MAILTO}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <TelegramIcon viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
        </TelegramIcon>
        Написать в поддержку
      </SupportButton>
    </SupportWrapper>
  );
};
